import React from 'react'
import { Icon,Tag } from 'antd';
import '../../css/svr_review_react.css'

export default  (props)=>{
    const {my_data_crreview} = props
    /*
     {
                                "rateKey": "20250615|20250616|W|1|297|DBL.ST|OPPRAIHBD|AI||1~1~0||N@07~~250f4~-186720143~N~~~NOR~~3E63FEAE94684DF174743279490405AAUK0003000100010721bd8",
                                "rateClass": "NOR",
                                "rateType": "BOOKABLE",
                                "net": "216.27",
                                "allotment": 24,
                                "rateCommentsId": "1|137844|0",
                                "paymentType": "AT_WEB",
                                "packaging": false,
                                "boardCode": "AI",
                                "boardName": "ALL INCLUSIVE",
                                "cancellationPolicies": [
                                    {
                                        "amount": "216.27",
                                        "from": "2025-06-07T23:59:00+02:00"
                                    }
                                ],
                                "taxes": {
                                    "taxes": [
                                        {
                                            "included": false,
                                            "amount": "3.30",
                                            "currency": "EUR",
                                            "clientAmount": "3.30",
                                            "clientCurrency": "EUR"
                                        }
                                    ],
                                    "allIncluded": false
                                },
                                "rooms": 1,
                                "adults": 1,
                                "children": 0,
                                "promotions": [
                                    {
                                        "code": "322",
                                        "name": "Online check-in"
                                    }
                                ]
                            }

    */
    //code start
    let Request = null
    let svcabinType = 'Interior'
        if(my_data_crreview && my_data_crreview.Request){
            Request = my_data_crreview.Request
            if (!( my_data_crreview.Request.cabinType && (my_data_crreview.Request.cabinType.length > 3)) ){
                svcabinType = 'Interior'
            }else{
                svcabinType = my_data_crreview.Request.cabinType
            }
        }else{
            Request = {
                "checkin": "Sun, Jun 15, 2025",
                "roomCode": "SGL",
                "stay": "6",
                "stayInit": "nights",
                "checkout": "Wed, Jun 25, 2025",
                "checkinTime": "Sat, Sept 9, 3027",
                "checkinTimePrefix": "From 3:00 PM",
                "checkoutTimePrefix": "Until 11:00 AM",
                "checkoutTime":  "Sat, Sept 16, 3027",
                
                "roomType": "Interior",
                "cabinType":"Interior",
                "departurePortName" : "Pointe-a-Pitre, Guadeloupe",
              "itineraryTitle" : "Southern Caribbean",
            }
        }
        const stayWithUnits = (Request.stay? Request.stay: '6')  + ' ' + (Request.stayInit? Request.stayInit: 'days') 
 

    //body start
    return (
        <div className="rev-row">
             <div className="card card--raised with-shadow">
                <p className="sd-content"> <text> Booking Details </text></p>
                <div className="box-outer">
                    <div className="rev-sd-left">
                        <p className="sd-check"><text>Check-in </text></p>
                        <p className="sd-content"><text style={{fontSize:'13px'}} >{Request.checkin  } </text></p>
                      
                        <p className="sd-check"><text>Room Type </text></p>
                        <p className="sd-check"><text>Cabin Type </text></p>
                        <p className="sd-check"><text>Guests </text></p>
                        <p className="sd-check"><text>Children </text></p>
                        <p className="sd-check"><text>Laving From </text></p>
                    </div>

                    <div className="rev-sd-right">

                        <p className="sd-check"><text>Check-out </text></p>
                        <p className="sd-content"><text style={{fontSize:'13px'}}>{Request.checkout }  </text></p>
                       
                
                        <p className="sd-check"><text>Stateroom </text></p>
                        <p className="sd-check"><text>{svcabinType} </text></p>
                        <p className="sd-check"><text>2 Adults </text></p>
                        <p className="sd-check"><text>0 </text></p>
                        <p className="sd-check"><text>{Request.departurePortName  } </text></p>
               
               
                    </div>

                </div>

                <p> <text> Total length of stay </text></p>
                <p> <text> {stayWithUnits? stayWithUnits:'6 days' } </text></p>
                <p> <text> Non Refundable With Deposit </text></p>
            </div>
            </div>
)
}